import * as React from "react";

import FlagCheckbox from "./FlagCheckbox";
import ResolveFlagForm from "./ResolveFlagForm";

const { FormattedDate } = require("react-intl");

interface FlagListItemProps {
  flag: any;
  app_id: number;
  hurdle_name: string;
  onUpdate: Function;
}

class FlagListItem extends React.Component<FlagListItemProps, any> {
  constructor(props: FlagListItemProps) {
    super(props);

    this.state = {
      showForm: false,
    };
  }

  handleClick() {
    this.setState({
      showForm: !this.state.showForm,
    });
  }

  render() {
    const { flag } = this.props;

    return (
      <li className="hurdle-checklist__item">
        <FlagCheckbox
          label={flag.message}
          inputName={`flag-${flag.id}`}
          isChecked={flag.resolved}
          onClick={this.handleClick.bind(this)}
        />
        {!flag.resolved && (
          <div>
            {this.state.showForm && (
              <ResolveFlagForm
                app_id={this.props.app_id}
                hurdle_name={this.props.hurdle_name}
                flag={flag}
                onUpdate={this.props.onUpdate}
                onClose={this.handleClick.bind(this)}
              />
            )}

            <div className="hurdle-communication__byline">
              <span className="hurdle-communication__author">
                Created by {flag.created_by_email}
              </span>
              <time className="hurdle-communication__date">
                <FormattedDate
                  value={flag.created_at}
                  year="numeric"
                  month="numeric"
                  day="numeric"
                  hour="numeric"
                  minute="numeric"
                />
              </time>
            </div>
          </div>
        )}

        {flag.resolved && (
          <div className="hurdle-communication__byline">
            <span className="hurdle-communication__author">
              Resolved by {flag.resolved_by_email}
            </span>
            <p>Resolution: {flag.resolution}</p>
          </div>
        )}
      </li>
    );
  }
}

export default FlagListItem;
